<template>
  <div class="container">
    <div class="row">
      <div class="col-12 head-atom">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">
            <div class="back-header">
              <span @click="$router.go(-1)">
                <i class="vik vik-left"></i>back
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="col">
        <div class="content atom">
          <div class="row item-container">
            <div class="col-lg-12">
              <div class="atom-content" style="align-items: flex-start;">
                <div class="info">
                  <div class="info-list">
                    <div class="info-item">
                      <h5>Tags:</h5>
                      <div class="info-item-desc">
                        <div class="tags">
                          <el-tag :key="index" v-for="(tag, index) in info.tags" :closable="true"
                            :disable-transitions="false" @close="handleCloseTag(tag)">
                            {{ tag }}
                          </el-tag>
                          <div>
                            <el-input class="input-new-tag" v-if="inputTagVisible" v-model="inputTagValue"
                              ref="saveTagInput" size="mini" @keyup.enter.native="handleInputTagConfirm"
                              @blur="handleInputTagConfirm">
                            </el-input>
                            <el-button v-else class="btn-sm btn-primary" @click="showTagInput"><i
                                class="vik vik-plus-small"></i> new
                              tag</el-button>
                          </div>

                          <!--
                          <span
                            :key="index"
                            v-for="(tag, index) in info.tags"
                            >{{ tag }}</span
                          >
                          -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="description" style="width: 100%">
                  <div class="description-cont">
                    <div class="head-description">
                    </div>
                    <div>
                      <NativeAtomBuilder></NativeAtomBuilder>
                    </div>
                    <!-- normal mode -->

                  </div>
                </div>
              </div>
              <!-- <div class="changelog">
                <div class="control-block d-flex align-items-center mb-4">
                  <div class="btn-line-icon">

                    <el-button class="btn-sm btn-link" @click="editMode = false">
                      <i class="vik vik-x"></i>
                    </el-button>
                    <el-button class="btn-sm btn-link" @click="handleSave" :loading="loading" icon="vik vik-save">
                    </el-button>
                  </div>

                </div>

                <div class="aux-block">
                  <button class="btn btn-lg btn-primary w-100" title="Not available" :disabled="!has_api_key"
                    type="button">
                    <i class="vik vik-share"></i>{{ publishText }}
                  </button>
                </div>
              </div> -->
            </div>


            <div>
              <div class="code-listing" v-if="localData != null">
                <h2 v-if="localData.code">Local code</h2>
                <CodeExpander v-show="localData.code">
                  <div class="black-editor-cont">
                    <Editor :editorId="'atom-editor'" ref="atomEditor" :readOnly="readOnlyEditor" theme="vikingo"
                      lang="lua"></Editor>
                  </div>
                </CodeExpander>
                <br />
                <h2 v-if="marketData.code">Market code</h2>
                <CodeExpander v-show="marketData.code">
                  <div class="black-editor-cont">
                    <Editor :editorId="'atom-editor-market'" ref="atomEditorMarket" :readOnly="true" theme="vikingo"
                      lang="lua"></Editor>
                  </div>
                </CodeExpander>
              </div>
            </div>

            <div>
              <!-- <div v-if="info.settings.length">
                <div class="atom-tree">
                  <ul>
                    <li class="atom-tree-item" inline :key="idx" v-for="(item, idx) in info.settings"
                      style="margin-bottom: 25px">
                      <el-form :ref="`paramForm` + idx" :model="item">
                        <div class="num">{{ idx + 1 }}.</div>
                        <div class="atom-tree-item-cont">
                          <el-form-item label="Title">
                            <el-input v-model="item.title" placeholder="For example: fisrt parameter"
                              :disabled="!editMode"></el-input>
                          </el-form-item>
                          <el-form-item prop="name" label="Name" :rules="{
                required: true,
                message: 'Name can not be empty',
                trigger: 'blur',
              }">
                            <el-input v-model="item.name" placeholder="For example: set_one"
                              :disabled="!editMode"></el-input>
                          </el-form-item>
                          <div class="item-cont-group">
                            <h4 class="tree-title-group">View</h4>
                            <div class="variables-group">
                              <el-form-item class="choose-var" prop="view">
                                <el-select v-model="item.view" :disabled="!editMode">
                                  <el-option value="multiselect">Multiselect</el-option>
                                  <el-option value="string">String</el-option>
                                  <el-option value="checkbox">Checkbox</el-option>
                                </el-select>
                              </el-form-item>

                              <div class="control-var-item">
                                <el-form-item prop="value">
                                  <el-checkbox v-if="item.view == 'checkbox'" v-model="item.modelBool"
                                    :disabled="!editMode">checked</el-checkbox>
                                  <el-select v-if="item.view == 'multiselect'" v-model="item.modelMultiselect"
                                    allow-create filterable multiple default-first-option :disabled="!editMode">
                                    <el-option v-for="val in item.value" :value="val" :key="val" :label="val">{{ val
                                      }}</el-option>
                                  </el-select>
                                  <el-input v-if="item.view == 'string'" v-model="item.modelString"
                                    placeholder="Default value" :disabled="!editMode"></el-input>
                                </el-form-item>
                              </div>
                            </div>
                          </div>
                          <el-form-item>
                            <button type="button" @click="handleRemove(idx)"
                              class="btn-sm btn-outline btn-outline-danger">
                              <i class="vik vik-delete"></i>Delete
                            </button>
                          </el-form-item>
                        </div>
                      </el-form>
                    </li>
                  </ul>
                </div>
              </div> -->
              <!-- <div class="form-group">
                <div class="btn-line">
                  <button @click="addSetting" type="button" class="btn btn-primary">
                    <i class="vik vik-plus"></i>Add setting
                  </button>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { bus } from "@/bus.js";
import NativeAtomBuilder from "@/components/internal/NativeAtomBuilder.vue";

export default {
  props: ["type"],
  components: { NativeAtomBuilder },
  data() {
    return {
      selectedAtomType: 'lua',
      info: {
        title: "",
        description: "",
        visibility: "private",
        settings: [],
        tags: [],
      },
      loading: true,
      atomType: "lua",
      inputTagVisible: false,
    };
  },

  computed: {
    currentBuilder() {
      return this.$route.params.type;
    },
  },
  created() {
    this.loading = true;
  },
  mounted() {
    this.loading = false;
  },
  methods: {},
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/NewAtom.vue